export interface DrillDownFilterColumnMapping {
  date: string;
  services: string;
  sites: string;
  cities: string;
  companyName: string;
  status?: string;
}
